import AddIcon from '@mui/icons-material/Add';
import { Box, Button, IconButton, Paper, Skeleton, Stack, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { INVOICE_BILLING_STATUSES, type InvoiceBillingStatus } from '@vy/types';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetInvoicesSummary } from '../../../../../../../../hooks/requests/use-get-invoices-summary';
import { useValidatedParams } from '../../../../../../../../hooks/use-validated-params';

export const FinancialInsightsInvoices: React.FC = () => {
  const navigate = useNavigate();
  const { customerId } = useValidatedParams<['customerId']>('customerId');
  const { data, isLoading } = useGetInvoicesSummary();

  const getValue = (key: InvoiceBillingStatus) => (isLoading ? <Skeleton /> : (data?.[key] ?? 0));

  const invoiceData = [
    {
      status: 'Open invoice',
      count: getValue(INVOICE_BILLING_STATUSES.None),
    },
    {
      status: 'Overdue',
      count: getValue(INVOICE_BILLING_STATUSES.Overdue),
    },
    {
      status: 'Pending Payment',
      count: getValue(INVOICE_BILLING_STATUSES.PendingPayment),
    },
    {
      status: 'Paid',
      count: getValue(INVOICE_BILLING_STATUSES.Paid),
    },
  ];

  return (
    <Paper sx={{ minWidth: 254, padding: '20px', borderRadius: '8px' }}>
      <Stack spacing={1}>
        <Stack direction="row" sx={{
          justifyContent: "space-between"
        }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "8px",
              alignItems: "center"
            }}>
            <VyIcon icon="InvoiceList" style={{ marginTop: '2px' }} />
            <Typography
              sx={{
                fontSize: "16px",
                color: "text.primary"
              }}>
              Invoices
            </Typography>
          </Box>

          <Button
            size="small"
            startIcon={
              <AddIcon
                fontSize="small"
                sx={{
                  color: 'text.primary',
                }}
              />
            }
            sx={{ textTransform: 'none', color: 'text.secondary' }}
            onClick={(event) => {
              event.stopPropagation();
              navigate(`/invoices/create?customerId=${customerId}`);
            }}
          >
            Invoice
          </Button>
        </Stack>

        <Stack spacing={2}>
          {invoiceData.map((item) => (
            <Stack key={item.status} direction="row" spacing={2} sx={{
              alignItems: "center"
            }}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  color: "text.primary",
                  flex: 1
                }}>
                {item.status} ({item.count})
              </Typography>
              <IconButton
                size="small"
                sx={{
                  borderRadius: '5px',
                  padding: '8px',
                  height: '32px',
                  width: '32px',
                }}
                onClick={() => navigate(`/customers/${customerId}/invoices`)}
              >
                <VyIcon icon="ArrowRight" style={{ color: '#323232' }} />
              </IconButton>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Paper>
  );
};
